// Aerator (mousseur) catalog — Neoperl reference data.
// `compatibleFaucetTypes` values must match technical_data.faucet_type on equipments
// (see FAUCET_TYPE_LABELS in AeratorSubModule.js): "technical" | "hand_wash" | "changing_room" | "other".
//
// Only `id`, `brand`, `model`, `flowRateLMin`, `compatibleFaucetTypes`, `technology`, `priceEur`
// and `notes` are currently read by FlowReductionWizard's model picker. The remaining fields
// (reference, family, connectionType/Size, catalogCategory, streamType, pressureCompensated,
// requiresKey, recommendedApplications, replacementFlowRateLMin, temporaryBoostFlowRateLMin,
// imageUrl) are kept for future use (richer product cards, install-compatibility checks) but not
// yet displayed.
export const AERATOR_CATALOG = [
  {
    id: 'neoperl-pca-cascade-1-9-std',
    brand: 'Neoperl',
    reference: '401059000',
    family: 'PCA Cascade',
    model: 'PCA Cascade 0.5 gpm',
    flowRateLMin: 1.9,
    priceEur: 4.5,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'PCA Cascade',
    connectionType: 'insert',
    connectionSize: 'STD/REG',
    catalogCategory: 'insert',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Lave-mains', 'Sanitaires', 'Bureaux'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783960702/walter%20assets/511eu-rxnZL._AC_UF1000_1000_QL80__bmqaqy.jpg',
    notes: 'Pièce intérieure uniquement. Débit très économe pour les lave-mains.',
  },
  {
    id: 'neoperl-pca-cascade-3-8-std',
    brand: 'Neoperl',
    reference: '401058000',
    family: 'PCA Cascade',
    model: 'PCA Cascade 1.0 gpm',
    flowRateLMin: 3.8,
    priceEur: 4.5,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'PCA Cascade',
    connectionType: 'insert',
    connectionSize: 'STD/REG',
    catalogCategory: 'insert',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Lavabo', 'Vestiaires', 'Bureaux'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783959887/walter%20assets/pm_11812_543_543366-9lpla7ypgi-800_qrszpb.jpg',
    notes: 'Pièce intérieure uniquement. Excellent compromis confort/économie.',
  },
  {
    id: 'neoperl-pca-cascade-5-std',
    brand: 'Neoperl',
    reference: '401051000',
    family: 'PCA Cascade',
    model: 'PCA Cascade 5 L/min',
    flowRateLMin: 5,
    priceEur: 4.5,
    compatibleFaucetTypes: ['hand_wash', 'changing_room', 'other'],
    technology: 'PCA Cascade',
    connectionType: 'insert',
    connectionSize: 'STD/REG',
    catalogCategory: 'insert',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Lavabo', 'Cuisine légère', 'Bureaux'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783960831/walter%20assets/neoperl-cascade-aerator-5.0-l-min-pca-orange-40.1051.0002-_2_-100618-p_doxerv.jpg',
    notes: 'Pièce intérieure uniquement. Le modèle universel recommandé.',
  },
  {
    id: 'neoperl-mini-ecobooster-5',
    brand: 'Neoperl',
    reference: '180407000',
    family: 'Mini Ecobooster',
    model: 'Mini Ecobooster 5 L/min',
    flowRateLMin: 5,
    priceEur: 12,
    temporaryBoostFlowRateLMin: 10,
    compatibleFaucetTypes: ['technical', 'other'],
    technology: 'Mini Ecobooster à double débit',
    connectionType: 'male',
    connectionSize: 'M24x1',
    catalogCategory: 'kitchen',
    streamType: 'aerated',
    pressureCompensated: false,
    requiresKey: false,
    recommendedApplications: ['Cuisine', 'Kitchenette', 'Salle de pause'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961019/walter%20assets/SET_123000_-67769af8b7fd7_eethcw.webp',
    notes: 'Débit réduit à 5 L/min avec possibilité de passer temporairement à 10 L/min en relevant la bague.',
  },
  {
    id: 'neoperl-rc-short-1-9',
    brand: 'Neoperl',
    reference: '023197000',
    family: 'Perlator RC Short',
    model: 'RC Short PCA 0.5 gpm',
    flowRateLMin: 1.9,
    priceEur: 12,
    compatibleFaucetTypes: ['technical', 'hand_wash', 'changing_room'],
    technology: 'PCA RC Short',
    connectionType: 'RC',
    connectionSize: 'RC 24x6 mm',
    catalogCategory: 'standard',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Robinetteries spécifiques'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961150/walter%20assets/41j-VKoE7eL._AC_SL1024__zcyzio.jpg',
    notes: 'Version RC courte.',
  },
  {
    id: 'neoperl-rc-short-3-8',
    brand: 'Neoperl',
    reference: '023198000',
    family: 'Perlator RC Short',
    model: 'RC Short PCA 1.0 gpm',
    flowRateLMin: 3.8,
    priceEur: 12,
    compatibleFaucetTypes: ['technical', 'hand_wash', 'changing_room'],
    technology: 'PCA RC Short',
    connectionType: 'RC',
    connectionSize: 'RC 24x6 mm',
    catalogCategory: 'standard',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Robinetteries spécifiques'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961150/walter%20assets/41j-VKoE7eL._AC_SL1024__zcyzio.jpg',
    notes: 'Version RC courte.',
  },
  {
    id: 'neoperl-cache-cascade-1-9',
    brand: 'Neoperl',
    reference: '401259010',
    family: 'CACHE Cascade',
    model: 'CACHE PCA 0.5 gpm',
    flowRateLMin: 1.9,
    priceEur: 9,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'CACHE PCA',
    connectionType: 'cache',
    connectionSize: 'CACHE M24x1',
    catalogCategory: 'cache',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: true,
    recommendedApplications: ['Lavabo', 'Robinet design'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961421/walter%20assets/401259010_L_2_zhx1fo.jpg',
    notes: 'Nécessite une clé CACHE.',
  },
  {
    id: 'neoperl-cache-cascade-3-8',
    brand: 'Neoperl',
    reference: '401258010',
    family: 'CACHE Cascade',
    model: 'CACHE PCA 1.0 gpm',
    flowRateLMin: 3.8,
    priceEur: 9,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'CACHE PCA',
    connectionType: 'cache',
    connectionSize: 'CACHE M24x1',
    catalogCategory: 'cache',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: true,
    recommendedApplications: ['Lavabo', 'Robinet design'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961499/walter%20assets/401258010_L_1_c1bhnj.jpg',
    notes: 'Nécessite une clé CACHE.',
  },
  {
    id: 'neoperl-coinslot-pca-3-8',
    brand: 'Neoperl',
    reference: '45304490',
    family: 'Coin Slot PCA',
    model: 'Coin Slot PCA 3.8 L/min',
    flowRateLMin: 3.8,
    priceEur: 4.5,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'Coin Slot PCA',
    connectionType: 'male',
    connectionSize: 'M24x1',
    catalogCategory: 'standard',
    streamType: 'aerated',
    pressureCompensated: true,
    requiresKey: false,
    recommendedApplications: ['Collectivités', 'Lavabos', 'Sanitaires'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783961862/walter%20assets/ProductStage_PERLATOR_CoinSlot_piyulc.webp',
    notes: 'Se démonte avec une simple pièce de monnaie.',
  },
  {
    id: 'neoperl-honeycomb-laminar-jr-3-8',
    brand: 'Neoperl',
    reference: '423131000',
    family: 'Perlator Honeycomb',
    model: 'Honeycomb Laminaire JR 1.0 gpm',
    flowRateLMin: 3.8,
    priceEur: 4.5,
    compatibleFaucetTypes: ['technical', 'hand_wash', 'changing_room'],
    technology: 'Jet laminaire Honeycomb',
    connectionType: 'insert',
    connectionSize: 'JR',
    catalogCategory: 'clinic',
    streamType: 'laminar',
    pressureCompensated: false,
    requiresKey: false,
    recommendedApplications: ['Hôpital', 'Clinique', 'Laboratoire', 'EHPAD'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783962132/walter%20assets/423131000_L_1_dya5ev.webp',
    notes: 'Pièce intérieure uniquement. Jet laminaire limitant les projections.',
  },
  {
    id: 'neoperl-honeycomb-clinic-8-3',
    brand: 'Neoperl',
    reference: '4021020A0',
    family: 'Honeycomb Clinic',
    model: 'Honeycomb Clinic',
    flowRateLMin: 8.3,
    priceEur: 4.5,
    compatibleFaucetTypes: ['hand_wash', 'changing_room'],
    technology: 'Honeycomb Clinic',
    connectionType: 'insert',
    connectionSize: 'Insert',
    catalogCategory: 'clinic',
    streamType: 'laminar',
    pressureCompensated: false,
    requiresKey: false,
    recommendedApplications: ['Clinique', 'Hôpital', 'Santé'],
    replacementFlowRateLMin: 12,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783962216/walter%20assets/4021020A0_L_2_lxybfc.webp',
    notes: 'Pièce intérieure uniquement. Débit moyen de 8,3 L/min (7,5 à 9 L/min à 3 bars).',
  },
];
